<nav
  class="navbar navbar-dark navbar-expand-lg sticky-top bg-white portfolio-navbar gradient">
  <div class="container-fluid">

    <div class="d-lg-flex justify-content-between w-100">

      <div class="d-flex justify-content-between">
        <img ngSrc="assets/home/home/logo_new.png" alt="logo"
             style="height: 2rem; width: auto; margin: 0 5px" loading="eager" height="441" width="1646">

        <button class="navbar-toggler bg-danger" (click)="toggleMobileNav()">
          <span class="visually-hidden">Toggle navigation</span>
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>

      <div id="navbarNav" class="d-none d-lg-flex mt-3 mt-md-0">
        <ul class="navbar-nav ms-auto">
        </ul>
      </div>
    </div>

  </div>
</nav>

<div class="container d-flex justify-content-center align-items-center" style="height: calc(100vh - 4rem);">

  <div class="bg-light rounded-3 shadow p-3 p-md-5 my-3">

    <div class="text-center">
      <i class="bi bi-check-circle-fill text-success" style="font-size: 5rem"></i>
    </div>

    <p class="text-center fs-4">
      Payment Successful!
    </p>

    <div class="text-center p-3">
      <p class="text-muted">Your booking has been created. Thank you for using SkyNet Online</p>
      <button routerLink="/individual/dashboard" class="btn btn-danger">
        Go to Dashboard
      </button>
    </div>
  </div>

</div>

